import { useEffect, useState } from 'react';
import { getNewMemberCampaignState } from '../services';
import { getEnv } from '../../environment';

//Normally, I would pull these values into their own file, but this hook is only used
//for a AB test around showing the timer. Removing it will be easier this way depending
//on test results.

//NMC pages
export const NEW_MEMBER_OPEN_SOON = 'NEW_MEMBER_OPEN_SOON';
export const NEW_MEMBER_OPEN = 'NEW_MEMBER_OPEN';
//NMC phase
export const NEW_MEMBER_CUSTOMIZE = 'NEW_MEMBER_CUSTOMIZE';

export function useNewMemberCampaignState(env, flag = false) {
  const [customizeInfo, setCustomizeInfo] = useState({});
  useEffect(() => {
    (async () => {
      if (flag) {
        try {
          const res = await getNewMemberCampaignState(getEnv(env));
          if (res?.userInfo && res?.campaignInfo) {
            setCustomizeInfo({
              customizePage: res.userInfo.customizePage,
              customizePhase: res.campaignInfo.campaignPhase,
            });
          }
        } catch (err) {
          console.error(err);
        }
      }
    })();
  }, [env, flag]);
  return customizeInfo;
}
